// extracted by mini-css-extract-plugin
export var border = "_d-7";
export var brand = "_d-r";
export var button = "_d-j";
export var center = "_d-9";
export var centered = "_d-5";
export var closeButton = "_d-b";
export var disabledWrapper = "_d-k";
export var error = "_d-n";
export var extraLarge = "_d-4";
export var extraSmall = "_d-1";
export var fill = "_d-g";
export var footer = "_d-f";
export var footerAction = "_d-h";
export var footerButtons = "_d-i";
export var header = "_d-6";
export var icon = "_d-m";
export var info = "_d-q";
export var inline = "_d-8";
export var large = "_d-3";
export var main = "_d-c";
export var modal = "_d-0";
export var neutral = "_d-s";
export var noPadding = "_d-e";
export var none = "_d-t";
export var scrollable = "_d-d";
export var small = "_d-2";
export var success = "_d-p";
export var tight = "_d-l";
export var titleIcon = "_d-a";
export var warn = "_d-o";